// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { UserEffects } from './store/effects';
import * as fromUser from './store/reducer';

// SERVICES
import { UserService } from './services/user.service';
import { UserStoreService } from './user-store.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['User'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure user ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 28-05-2020 User store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('user', fromUser.reducer, { metaReducers }),
    EffectsModule.forFeature([UserEffects]),
  ],
  declarations: [],
  providers: [
    UserService,
    UserStoreService,
  ],
})
export class UserStoreModule { }
